import i18n from '@/i18n';

export default [
  {
    path: '/contracts',
    name: 'contracts',
    meta: {
      loadState: true,
      auth: true,
      isAuthPage: false,
      permissions: [
        {
          subject: 'contract',
          actions: ['list-all'],
        },
      ],
      title: i18n.global.t('contracts')
    },
    // route level code-splitting
    component: () =>
      import('../../views/contracts/Index'),
    children: [
      {
        path: 'new',
        name: 'contracts-new',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'contract',
              actions: ['store'],
            },
          ],
          title: i18n.global.t('contracts'),
        },
        component: () => import('../../views/contracts/AddNew.vue'),
      },
      {
        path: ':id(\\d+)',
        name: 'contracts-edit',
        meta: {
          loadState: true,
          auth: true,
          isAuthPage: false,
          permissions: [
            {
              subject: 'contract',
              actions: ['view'],
            },
          ],
          title: i18n.global.t('contracts'),
        },
        component: () => import('../../views/contracts/Edit.vue'),
      },
    ],
  },
];
